import { Box } from '@bechtel/gds';
import styled from 'styled-components';
import { ModalHeader } from '@bechtel/gds';

export const RemoveImportUsersModelBlockStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  p: { sm: '500' },
})`
  ${({ theme }) =>
    `border-bottom: 1px solid ${theme.colors.grey[300]};
     background-color: ${theme.colors.grey[100]};
     width:100%;
     
  `}
`;
export const RemoveImportUsersModelActionBlockStyled = styled(Box).attrs({
  p: { sm: '500' },
})`
  ${({ theme }) =>
    `border-bottom: 1px solid ${theme.colors.grey[300]};
     width:100%;
  `}
`;
export const ModalHeaderStyled = styled(ModalHeader)`
  background-color: ${({ theme }) => theme.colors.red[700]};
  border: 0px;
`;

export const ModalFooterStyled = styled(Box).attrs({
  p: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%);
  width: 100%;
`;

export const ImportUsersItemContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
  pb: { sm: '100' },
})`
  height: 100vh;
  width: 100%;
`;

export const ImportUsersItemStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '550' },
})`
  ${({ theme }) =>
    `border-bottom: 1px solid ${theme.colors.grey[300]};
     width:100%;
  `}
`;
